import BaseMapWrapper from "../utils/BaseMapWrapper";
import MapService from "./map";
export default class MapboxWrapper extends BaseMapWrapper {
  getServiceConstructor() {
    return MapService;
  }
}